/// <reference path="./react-table-config.d.ts" />
import { ReactElement } from 'react';
import { Column, PluginHook, TableState, useSortBy } from 'react-table';

import { MessageType } from '@savgroup-front-common/types';

import { ComponentErrorBoundary } from '../../molecules/ErrorBoundary';

import TableContent from './TableContent';

interface TableProps<D extends Record<string, any>> {
  data: D[];
  columns: Column<D>[];
  plugins?: PluginHook<D>[];
  initialState?: Partial<TableState<D>>;
  dataTestId?: string;
  showSearch?: boolean;
  searchPlaceholder?: MessageType;
}

const Table = <D extends Record<string, any>>({
  columns,
  data,
  plugins = [useSortBy],
  initialState,
  dataTestId,
  showSearch,
  searchPlaceholder,
}: TableProps<D>): ReactElement | null => {
  return (
    <ComponentErrorBoundary>
      <TableContent<D>
        columns={columns}
        data={data}
        plugins={plugins}
        initialState={initialState}
        dataTestId={dataTestId}
        showSearch={showSearch}
        searchPlaceholder={searchPlaceholder}
      />
    </ComponentErrorBoundary>
  );
};

export default Table;
